import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "@/views/Home.vue";
import PublicUserViewOffers from "@/views/PublicUserViewOffers.vue";
import About from "@/views/About.vue";
import LegalNotice from "@/views/LegalNotice.vue";
import Contact from "@/views/Contact.vue";
import MyAccount from "@/views/MyAccount.vue";
import ResetPasswordPage from "@/views/ResetPasswordPage.vue";
import Logout from "@/views/Logout.vue";
import CandidateAccount from "@/views/Candidate/CandidateAccount.vue";
import CandidateMyAccount from "@/views/Candidate/CandidateMyAccount.vue";
import CandidateMyResearch from "@/views/Candidate/CandidateMyResearch.vue";
import CandidateOffers from "@/views/Candidate/CandidateOffers.vue";
import CompanyCvTheque from "@/views/Company/CompanyCvTheque.vue";
import CandidateMyAlerts from "@/views/Candidate/CandidateMyAlerts.vue";
import CandidateMyApplications from "@/views/Candidate/CandidateMyApplications.vue";
import CandidateManageResume from "@/views/Candidate/CandidateManageResume.vue";
import CandidateMyLastResearch from "@/views/Candidate/CandidateMyLastResearch.vue";
import CandidateMySavedOffer from "@/views/Candidate/CandidateMySavedOffer.vue";
import CandidateApplyToOffer from "@/views/Candidate/CandidateApplyToOffer.vue";
import CompanyAccount from "@/views/Company/CompanyAccount.vue";
import CompanyMyAccount from "@/views/Company/CompanyMyAccount.vue";
import CompanyPersonalInformation from "@/views/Company/CompanyPersonalInformation.vue";
import CompanyOffers from "@/views/Company/CompanyOffers.vue";
import CompanyManageMyPage from "@/views/Company/CompanyManageMyPage.vue";
import CompanyAddOffer from "@/views/Company/CompanyAddOffer.vue";
import CompanyEditOffer from "@/views/Company/CompanyEditOffer.vue";
import CompanyViewApplications from "@/views/Company/CompanyViewApplications.vue";
import HttpClient from "@/services/HttpClient/HttpClient";
import NotFound from "@/views/404notFound.vue";
import ViewCompanyPage from "@/views/ViewCompanyPage.vue";
import Conditions from "@/views/Conditions.vue";
import ConfirmEmailPage from "@/views/ConfirmEmailPage.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  // Commons URLS
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about-us",
    name: "About",
    component: About,
  },
  {
    path: "/legal-notice",
    name: "LegalNotice",
    component: LegalNotice,
  },
  {
    path: "/terms-of-service",
    name: "Conditions",
    component: Conditions,
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: Contact,
  },
  {
    path: "/offres",
    name: "PublicUserViewOffers",
    component: PublicUserViewOffers,
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/my-account",
    name: "MyAccount",
    component: MyAccount,
    meta: {
      requiresCustomAuth: true,
    },
  },
  // Candidate URLs
  {
    path: "/candidate/account",
    name: "CandidateAccount",
    component: CandidateAccount,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/my-account",
    name: "CandidateMyAccount",
    component: CandidateMyAccount,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/my-job-research",
    name: "CandidateMyJobResearch",
    component: CandidateMyResearch,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/offers",
    name: "CandidateOffers",
    component: CandidateOffers,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/alerts/manage",
    name: "CandidateMyAlerts",
    component: CandidateMyAlerts,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/last-research/manage",
    name: "CandidateMyLastResearch",
    component: CandidateMyLastResearch,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/saved-offers/manage",
    name: "CandidateMySavedOffer",
    component: CandidateMySavedOffer,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/apply/:offerId",
    name: "CandidateApplyToOffer",
    component: CandidateApplyToOffer,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/my-applications",
    name: "CandidateMyApplications",
    component: CandidateMyApplications,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  {
    path: "/candidate/cv",
    name: "CandidateManageResume",
    component: CandidateManageResume,
    meta: {
      requiresAuth: true,
      roleSeeker: true,
    },
  },
  // Company URLS
  {
    path: "/company/account",
    name: "CompanyAccount",
    component: CompanyAccount,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  {
    path: "/company/my-account",
    name: "CompanyMyAccount",
    component: CompanyMyAccount,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  {
    path: "/company/personal-informations",
    name: "CompanyPersonalInformation",
    component: CompanyPersonalInformation,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  {
    path: "/company/page/:companyId",
    name: "ViewCompanyPage",
    component: ViewCompanyPage,
    meta: {},
  },
  {
    path: "/auth/reset-password/:token",
    name: "RestPasswordPage",
    component: ResetPasswordPage,
    meta: {},
  },
  {
    path: "/auth/enable-account/:token",
    name: "ConfirmEmailPage",
    component: ConfirmEmailPage,
    meta: {},
  },
  {
    path: "/company/manage/my-page",
    name: "CompanyManageMyPage",
    component: CompanyManageMyPage,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  {
    path: "/company/cv-theque",
    name: "CompanyCvTheque",
    component: CompanyCvTheque,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  {
    path: "/company/offers",
    name: "CompanyOffers",
    component: CompanyOffers,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  {
    path: "/company/new/offer",
    name: "CompanyAddOffer",
    component: CompanyAddOffer,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  // {
  //   path: "/company/cv-theque",
  //   name: "CompanyAddOffer",
  //   component: CompanyAddOffer,
  //   meta: {
  //     requiresAuth: true,
  //     roleCompany: true,
  //   },
  // },
  {
    path: "/company/edit/offer/:offerId",
    name: "CompanyEditOffer",
    component: CompanyEditOffer,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  {
    path: "/company/offer/:offerId/applications",
    name: "CompanyViewApplications",
    component: CompanyViewApplications,
    meta: {
      requiresAuth: true,
      roleCompany: true,
    },
  },
  // admin URL
  // 404 not found
  {
    // will match everything
    path: "*",
    name: "not_found",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const httpClient = new HttpClient();

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt-token") === null) {
      next({
        path: "/my-account",
        query: { nextUrl: to.fullPath },
      });
    } else {
      // check if token is still valid
      httpClient
        .getCurrentUserInformations(<string>localStorage.getItem("jwt-token"))
        .then((value) => {
          const user = JSON.parse(<string>localStorage.getItem("currentUser"));
          if (to.matched.some((record) => record.meta.roleCompany)) {
            if (user.roles.includes("ROLE_COMPANY")) {
              next();
            } else {
              next({
                name: "MyAccount",
                query: {
                  reload: "true",
                  nextUrl: to.fullPath,
                },
              });
            }
          } else if (to.matched.some((record) => record.meta.roleSeeker)) {
            if (user.roles.includes("ROLE_SEEKER")) {
              next();
            } else {
              next({
                name: "MyAccount",
                query: {
                  reload: "true",
                  nextUrl: to.fullPath,
                },
              });
            }
          } else {
            next();
          }
        })
        .catch((reason) => {
          localStorage.removeItem("jwt-token");
          localStorage.removeItem("currentUser");
          next({
            path: "/my-account",
            query: {
              reload: "true",
              nextUrl: to.fullPath,
            },
          });
        });
    }
  } else if (to.matched.some((record: any) => record.meta.requiresCustomAuth)) {
    if (localStorage.getItem("jwt-token") === null) {
      next();
    } else {
      // check if token is still valid
      httpClient
        .getCurrentUserInformations(<string>localStorage.getItem("jwt-token"))
        .then((value) => {
          const user = JSON.parse(<string>localStorage.getItem("currentUser"));
          if (user.roles.includes("ROLE_COMPANY")) {
            next({ name: "CompanyAccount" });
          } else if (user.roles.includes("ROLE_SEEKER")) {
            next({ name: "CandidateOffers" });
          }
        })
        .catch((reason) => {
          localStorage.removeItem("jwt-token");
          localStorage.removeItem("currentUser");
          next();
        });
    }
  } else {
    next();
  }
});
export default router;
